import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { InfoTag, RightChevronButtonIcon, Typography, getTestId } from '@airtel/air-design-system';
import { View } from 'react-native';
import { TEXT_TYPE } from '../../InfoSummaryWidgetConstants';
import { getHeadingTabStyles } from './HeadingTabStyles';
export var HeadingTab = props => {
  var _a, _b, _c;
  var singleCardDetails = props.singleCardDetails,
    isMobileScreen = props.isMobileScreen,
    id = props.id,
    onUserAction = props.onUserAction;
  var onRightChevronPress = singleCardDetails.onRightChevronPress;
  var _ref = (_a = singleCardDetails === null || singleCardDetails === void 0 ? void 0 : singleCardDetails.infoTagSubHeaderProps) !== null && _a !== void 0 ? _a : {},
    subType = _ref.subType,
    text = _ref.text,
    iconName = _ref.iconName,
    iconPosition = _ref.iconPosition;
  var headingTabStyles = getHeadingTabStyles();
  return _jsxs(View, Object.assign({
    style: [headingTabStyles === null || headingTabStyles === void 0 ? void 0 : headingTabStyles.headerWrapper, !(singleCardDetails === null || singleCardDetails === void 0 ? void 0 : singleCardDetails.subtitleText) && headingTabStyles.headerWrapperNullStartElement]
  }, {
    children: [!!(singleCardDetails === null || singleCardDetails === void 0 ? void 0 : singleCardDetails.subtitleText) && _jsx(View, Object.assign({
      style: headingTabStyles.headerTextWrapper
    }, {
      children: _jsx(Typography, Object.assign({
        type: isMobileScreen ? TEXT_TYPE.BODY_PARA_LG_BOLD : TEXT_TYPE.BODY_PARA_XL_BOLD,
        text: singleCardDetails === null || singleCardDetails === void 0 ? void 0 : singleCardDetails.subtitleText
      }, getTestId(props === null || props === void 0 ? void 0 : props.testID, 'subtitleText')))
    })), (((_b = singleCardDetails === null || singleCardDetails === void 0 ? void 0 : singleCardDetails.rightChevronProps) === null || _b === void 0 ? void 0 : _b.showIcon) || (singleCardDetails === null || singleCardDetails === void 0 ? void 0 : singleCardDetails.infoTagSubHeaderProps)) && _jsxs(View, Object.assign({
      style: headingTabStyles === null || headingTabStyles === void 0 ? void 0 : headingTabStyles.headerOneInfoCTAWrapper
    }, {
      children: [(singleCardDetails === null || singleCardDetails === void 0 ? void 0 : singleCardDetails.infoTagSubHeaderProps) && _jsx(View, Object.assign({
        style: headingTabStyles === null || headingTabStyles === void 0 ? void 0 : headingTabStyles.headerOneInfoWrapper
      }, {
        children: _jsx(InfoTag, Object.assign({
          subType: subType,
          text: text,
          iconName: iconName,
          iconPosition: iconPosition,
          size: isMobileScreen ? TEXT_TYPE.MD : TEXT_TYPE.LG
        }, getTestId(props === null || props === void 0 ? void 0 : props.testID, 'infoTagSubHeaderProps')))
      })), !!((_c = singleCardDetails === null || singleCardDetails === void 0 ? void 0 : singleCardDetails.rightChevronProps) === null || _c === void 0 ? void 0 : _c.showIcon) && _jsx(RightChevronButtonIcon, {
        fontSize: 20,
        onPress: () => {
          onRightChevronPress && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
            id
          }, onRightChevronPress)));
        }
      })]
    }))]
  }));
};
export default HeadingTab;